import { Component, EventEmitter, Output, TemplateRef, ViewChild } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { CompanyManageService } from '../../../service/api/jubili/company-manage.service';
import { UpdateLpmModel } from '../../../model/jubili/company-manage/update-lpm';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-jubili-lpm-edit-modal',
  templateUrl: './jubili-lpm-edit-modal.component.html',
  styleUrls: ['./jubili-lpm-edit-modal.component.scss']
})
export class JubiliLpmEditModalComponent {
  modalRef: BsModalRef;
  @Output() closeModalEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() confirm: EventEmitter<boolean> = new EventEmitter<boolean>();
  @ViewChild('content') content: TemplateRef<any>;

  companySurrKey: number;

  updateModel: UpdateLpmModel;

  // form
  form: FormGroup;

  constructor(
    private modalService: BsModalService,
    private companyManageService: CompanyManageService,
    private formBuilder: FormBuilder
    ) { }

  open(companySurrKey: number, lpmName: string): void {
    this.updateModel = new UpdateLpmModel();
    this.companySurrKey = companySurrKey;
    this.updateModel.companySurrKey = this.companySurrKey;
    this.updateModel.lpmName = lpmName;
    this.initForm();
    this.initDetail();
    this.modalRef = this.modalService.show(this.content, {
      class: 'modal-md modal-dialog-centered'
    });
  }

  close(): void {
    this.modalRef.hide();
    this.closeModalEvent.emit(true);
  }

  initForm() {
    this.form = this.formBuilder.group({
      lpmName: ["", [Validators.required, Validators.nullValidator, Validators.pattern(/^\S.*\S$/)]]
    });
  }

  initDetail() {
    this.form.controls["lpmName"].setValue(this.updateModel.lpmName);
  }

  validateForm(): boolean {
    let checkFormValidate = false;
    this.form.controls["lpmName"].markAsTouched();

    checkFormValidate = this.form.valid;
    return checkFormValidate;
  }

  updateLpmName() {
    if (!this.validateForm()) {
      return;
    }
    this.updateModel.companySurrKey = this.companySurrKey;
    this.updateModel.lpmName = this.form.controls["lpmName"].value;
    this.companyManageService.updateLpmName(this.updateModel).subscribe(res => {
      if (res == true) {
        this.confirm.emit(res);
        this.close();
      }
    })
  }
}
